module.exports = __webpack_public_path__ + "img/conserveio.5af1134f.png";